import jwtDecode from 'jwt-decode';

import { LOC_STORAGE_JWT_KEY } from 'shared/constants/web';


const decodeJwt = (jwt) => {
  if (typeof jwt !== 'string') {
    return {};
  }

  return jwtDecode(jwt);
};


const webAdaptor = {
  get() {
    return window.localStorage.getItem(LOC_STORAGE_JWT_KEY);
  },

  set(jwt) {
    return window.localStorage.setItem(LOC_STORAGE_JWT_KEY, jwt);
  },

  remove() {
    return window.localStorage.removeItem(LOC_STORAGE_JWT_KEY);
  },
};


class JwtStore {
  constructor() {
    if (window) {
      this.adaptor = webAdaptor;
    } else {
      // TODO: Placeholder for other runtime env, like ios or android etc..
      this.adaptor = null;
    }
  }

  get() {
    return this.adaptor.get();
  }

  set(jwt) {
    this.adaptor.set(jwt);
    return decodeJwt(jwt);
  }

  remove() {
    return this.adaptor.remove();
  }
}


export default new JwtStore();
export {
  decodeJwt,
};



// WEBPACK FOOTER //
// ./src/shared/helpers/jwtStore.js